import React from 'react';
import Head from 'next/head';
import config from '~config/config';

interface HeadComponentProps {
  seoTitle?: string;
  seodescription?: string;
  canonicalUrl?: string;
  liveStreamUrl?: string;
}

const HeadComponent = (props: HeadComponentProps) => {
  let { seoTitle, seodescription, liveStreamUrl } = props;

  !seoTitle || seoTitle === ''
    ? (seoTitle = 'Vodafone Televiziune şi Internet Fix')
    : '';

  return (
    <Head>
      <title>{seoTitle}</title>
      <meta name='viewport' content='initial-scale=1.0, width=device-width' />
      <meta httpEquiv='X-UA-Compatible' content='IE=edge,chrome=1' />
      <meta name='description' content={seodescription} />
      <meta name='robots' content='index, follow' />
      <link
        rel='icon'
        type='image/x-icon'
        href='/servicii-fixe/static/favicon.ico'
      />
      <meta
        name='google-site-verification'
        content='twmtdU0_8_FEF6BmevvhhnyEBv82Gyf6VgjkoNb3JJo'
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.utag_cfg_ovrd = { noview: true };window.utag_data={};dataLayer = window.dataLayer || [];`,
        }}
      />
      <script
        src={`//tags.tiqcdn.com/utag/vodafone/ro-main-spa/${config.TEALIUM_ENV}/utag.js`}
        key='utagscript'
      />
      {liveStreamUrl !== undefined && (
        <script
          id='player_embed'
          src={liveStreamUrl}
          type='text/javascript'
          async={true}
        ></script>
      )}
    </Head>
  );
};

export default HeadComponent;
